// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2jj-T","info":"UpdateTermsInfo_info__2ZFXM"};